import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { EMPTY, Observable, Subscription } from "rxjs";
import { InquiryService } from '@service/api/inquiry.service';
import { LooseObject } from '@interface/looseobject.interface';
import { HydraConstraint } from '@interface/hydra/constraint.interface';
import { Inquiry } from '@interface/inquiry.interface';
import { catchError } from 'rxjs/operators';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {

  constructor(
    private fb: FormBuilder,
    private titleService: Title,
    private meta: Meta,
    protected api: InquiryService

  ) {
    this.titleService.setTitle('M|Catering - Contact Michigan Catering')
    this.meta.updateTag({
      name: 'description',
      content: ' Contact Michigan Catering’s team of preparers and planners to  begin planning your wedding, party or special event. Located at the University of Michigan in Ann Arbor.'
    });
    this.meta.updateTag({
      name: 'og:title',
      content: 'Contact Michigan Catering'
    });
    this.meta.updateTag({
      name: 'og:description',
      content: 'Contact Michigan Catering’s team of preparers and planners to  begin planning your wedding, party or special event. Located at the University of Michigan in Ann Arbor.'
    });
  }

  //@ViewChild(FormInquiryComponent) formInquiryComponent!: FormInquiryComponent;
  subscription$: Subscription = new Subscription();
  selectedOption: string = '0';

  posted: boolean = false;
  form: FormGroup = this.fb.group({
    'firstName': ['', [Validators.required, Validators.minLength(2), Validators.maxLength(45)]],
    'lastName': ['', [Validators.required, Validators.minLength(2), Validators.maxLength(45)]],
    'email': ['', [Validators.required, Validators.email, Validators.minLength(5), Validators.maxLength(255)]],
    'phone': ['', [Validators.required, Validators.minLength(10), Validators.maxLength(12)]],
    'subject': ['', [Validators.required, Validators.minLength(2), Validators.maxLength(255)]],
    'message': ['', [Validators.required, Validators.minLength(25), Validators.maxLength(5000)]],
    'captcha': ['', [Validators.required]]
  });

  isRequired(field: string): boolean {
    let ctrl = this.form.get(field) as FormControl;
    if (ctrl && ctrl?.errors?.required && ctrl?.touched) {
      return false;
    }
    return true;
  }
  isEmail(field: string): boolean {
    let ctrl = this.form.get(field) as FormControl;
    if (ctrl && ctrl?.errors?.email && ctrl?.touched) {
      return false;
    }
    return true;
  }
  isMin(field: string): boolean {
    let ctrl = this.form.get(field) as FormControl;
    if (ctrl && ctrl?.errors?.minlength && ctrl?.touched) {
      return false;
    }
    return true;
  }
  isMax(field: string): boolean {
    let ctrl = this.form.get(field) as FormControl;
    if (ctrl && ctrl?.errors?.maxlength && ctrl?.touched) {
      return false;
    }
    return true;
  }
  resolved(captchaResponse: string) {
    let recaptcha = this.form.get('captcha') as FormControl;
    recaptcha.setValue(captchaResponse);
  }
  /*
  submit():void {
    if(this.form.valid) {
      let data = new FormData();
      for(const x in this.form.value) {
        data.append(x, this.form.value[x])
      }

      /*
      this.http.post('/api/mail/index.php', data).subscribe((data:any) => {
        if(data.success == true) {
          this.posted = true;
        }
      });
      
    }
  }*/

  submit(): void {
    if (this.form.valid) {
      let values = this.form.value;
      this._queryApi(values);
    }
  }

  _queryApi(values: Inquiry) {
    this.subscription$ = this.api.create<Inquiry>(values).pipe(
      catchError((data: any) => {
        data = data.error;
        this._processConstraints(data);
        return EMPTY;
      })
    ).subscribe((data: Inquiry) => {
      this.posted = true;
    });
  }

  //Process error
  _processConstraints(data: HydraConstraint) {
    if (data['@type'] === 'ConstraintViolationList') {
      let obj: LooseObject = {};
      let childForm = this.form
      if (childForm) {
        data.violations.forEach((element: any) => {
          let control = childForm.get(element.propertyPath) as FormControl;
          control.setErrors({
            server: element.message
          });
        });
        this.form.setErrors({ error: true });

      }
    }
  }
  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

}
